export default {
    captchaImg: null,
    captchaTag: null,
    countdown: 0,
    brand_new: false,
};



// WEBPACK FOOTER //
// ./src/store/auth/state.js